import { AuthConfig } from 'angular-oauth2-oidc';

export const environment = {
  production: false,
  stage: 'dev',
  yardApiUrl: 'https://yard-api.dev.doka.com',
};

export const authCodeFlowConfig: AuthConfig = {
  issuer: 'https://login.test.doka.com',
  redirectUri: 'https://dap.dev.doka.com/apps',
  strictDiscoveryDocumentValidation: false,
  clientId: '6aa585a1-82c7-4755-bcaa-2f684bfb2f6d',
  responseType: 'code',
  scope:
    'openid profile email roles offline_access yard-api.doka.com/applications.read yard-api.doka.com/users.read',
  oidc: true,
  showDebugInformation: true,
  logoutUrl: 'https://login.test.doka.com/connect/endsession',
  tokenEndpoint: 'https://login.test.doka.com/connect/token',
  postLogoutRedirectUri: 'https://dap.dev.doka.com/logout',
};
